import { createFileRoute } from "@tanstack/react-router";

// Route metadata + search-param validation. Component lives in
// `billing.lazy.tsx`. We accept two optional query params:
//
//   ?checkout=success|cancel   — Stripe Checkout return state
//   ?upgrade=<plan_slug>        — auto-trigger Checkout for this plan
//                                  (used by the post-signup hand-off
//                                   from marketing pricing → admin-ui)
export const Route = createFileRoute("/app/settings/billing")({
  validateSearch: (search: Record<string, unknown>) => {
    const out: { checkout?: "success" | "cancel"; upgrade?: "starter" | "pro" | "agency" } = {};
    if (search.checkout === "success" || search.checkout === "cancel") {
      out.checkout = search.checkout;
    }
    if (
      typeof search.upgrade === "string" &&
      ["starter", "pro", "agency"].includes(search.upgrade)
    ) {
      out.upgrade = search.upgrade as "starter" | "pro" | "agency";
    }
    return out;
  },
});
